(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gallery"] && !Shopify.designMode) return;
  try {
    class GalleryLightbox extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
      this.modalImage = null;
      this.closeButton = null;
      this.backdrop = null;
    }

    connectedCallback() {
      if (!this.dataset.lightbox) return;

      this.modal = this.querySelector('.gallery-lightbox-modal');
      this.modalImage = this.querySelector('.gallery-lightbox-modal__image');
      this.closeButton = this.querySelector('.gallery-lightbox-modal__close');
      this.backdrop = this.querySelector('.gallery-lightbox-modal__backdrop');

      if (!this.modal) return;

      // Bind event handlers
      this.handleImageClick = this.handleImageClick.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      // Add click listeners to all images
      this.querySelectorAll('.image-block').forEach((imageBlock) => {
        imageBlock.addEventListener('click', this.handleImageClick);
      });

      // Close button click
      this.closeButton?.addEventListener('click', this.handleClose);

      // Backdrop click
      this.backdrop?.addEventListener('click', this.handleClose);

      // Escape key
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKeydown);
    }

    handleImageClick(event) {
      const img = event.currentTarget.querySelector('img');
      if (!img) return;

      // Get the high-res version by removing size constraints from Shopify CDN URL
      let src = img.src;
      // Try to get original size image from Shopify CDN
      src = src.replace(/(_\d+x\d+|_\d+x|_x\d+)(\.(jpg|jpeg|png|webp|gif))/i, '$2');

      // Show loading state
      this.modal.classList.add('gallery-lightbox-modal--loading');

      // Set up load handler before setting src
      this.modalImage.onload = () => {
        this.modal.classList.remove('gallery-lightbox-modal--loading');
      };
      this.modalImage.onerror = () => {
        this.modal.classList.remove('gallery-lightbox-modal--loading');
      };

      this.modalImage.src = src;
      this.modalImage.alt = img.alt || '';
      this.openModal();
    }

    openModal() {
      // Move modal to body to escape any stacking contexts
      document.body.appendChild(this.modal);
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gallery-lightbox-open');
    }

    handleClose() {
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gallery-lightbox-open');
      // Clear image and move modal back after transition
      setTimeout(() => {
        this.modalImage.src = '';
        this.modal.classList.remove('gallery-lightbox-modal--loading');
        this.appendChild(this.modal);
      }, 300);
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.modal?.getAttribute('aria-hidden') === 'false') {
        this.handleClose();
      }
    }
  }

  if (!customElements.get('gallery-lightbox')) {
    customElements.define('gallery-lightbox', GalleryLightbox);
  }
  } catch(e) { console.error(e); }
})();

})();
